import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Question = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M9 2a7 7 0 1 1 0 14A7 7 0 0 1 9 2m0 10a.746.746 0 0 0-.743.75c0 .414.332.75.742.75s.743-.336.743-.75A.746.746 0 0 0 9 12m.059-7.5c-.785 0-1.416.25-1.876.75-.456.497-.683.947-.683 1.744v.135c0 .37.3.67.67.67a.677.677 0 0 0 .677-.67l.001-.126c.016-.418.08-.528.186-.733.179-.35.497-.522.989-.522.4 0 .668.1.821.29.168.209.251.452.251.74q0 .299-.172.583a1.5 1.5 0 0 1-.261.322l-.414.412q-.619.612-.813 1.113-.19.495-.189 1.272v.122a.674.674 0 1 0 1.349 0v-.122q.001-.61.127-.896c.084-.19.28-.442.59-.745.461-.451.77-.795.93-1.04q.259-.4.258-1.01c0-.663-.226-1.217-.675-1.647-.447-.429-1.04-.642-1.766-.642"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Question$1 = Svg18Question;

export { Svg18Question$1 as default };
